var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    {
      staticClass: "numeric",
      attrs: { label: _vm.label, prop: _vm.prop, rules: _vm.rules }
    },
    [
      _c("el-input-number", {
        staticClass: "no-spin",
        attrs: {
          "controls-position": "right",
          maxlength: 5,
          placeholder: _vm.placeholder,
          disabled: _vm.disabled,
          min: _vm.min,
          max: _vm.max,
          precision: _vm.precision,
          step: _vm.step,
          autofocus: _vm.autofocus
        },
        model: {
          value: _vm.numeric,
          callback: function($$v) {
            _vm.numeric = $$v
          },
          expression: "numeric"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }